import axios from 'axios';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import { ACTOR, FLOW_TYPE, REDIRECT_SUFFIX } from '../../../framework/App/AppConstants';
import Button, { BUTTON_STYLE } from '../../../shared-components/Button/Button';
import RedirectButton from '../../../shared-components/RedirectButton/RedirectButton';
import Col from '../../../shared-components/VXGrid/Col';
import Row from '../../../shared-components/VXGrid/Row';
import { APPLICATION_STATUS } from '../../USConstants';
import setUrl from '../../../framework/App/SetUrl';
import { PAGE_NAME } from '../../config/pageNames';
import createDecisionPageGetter from '../../../shared-utilities/message-utilities/createDecisionPageGetter';
import ensureApplicationStatusMessages from '../../../shared-utilities/message-utilities/ensureApplicationStatusMessages';

const LOCALE_PREFIX = 'US/pages/DecisionPage/DecisionDeclined';
const HEADER_KEY = 'header';
const DECLINED_BUTTON_LABEL_KEY = 'declinedButtonLabel';
const PRIMARY_MESSAGE_KEY = 'primaryMessage';
const SECONDARY_MESSAGE_KEY = 'secondaryMessage';
const TESLA_KEY = 'tesla';
const UPDATE_EMAIL_LINK = 'https://www.paypal.com/myaccount/settings/email/add';

export class DecisionDeclined extends Component {
    static propTypes = {
        _csrf: PropTypes.string,
        intl: intlShape.isRequired,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        actor: PropTypes.oneOf(Object.values(ACTOR)),
        applyType: PropTypes.string.isRequired,
        merchantName: PropTypes.string,
        applicationStatus: PropTypes.string,
        isMiniBrowser: PropTypes.bool,
        isMobile: PropTypes.bool,
        handleUpdateEmail: PropTypes.func.isRequired,
        messages: PropTypes.object.isRequired,
        showPaymentSecurityMessage: PropTypes.bool,
    };

    render() {
        const {
            intl, messages, flow, actor, applicationStatus, merchantName, handleUpdateEmail, isMobile, showPaymentSecurityMessage
        } = this.props;

        const appStatus = ensureApplicationStatusMessages(messages, LOCALE_PREFIX, applicationStatus, ['header', 'primaryMessage']);
        const i18n = createDecisionPageGetter(intl, messages, LOCALE_PREFIX, appStatus, merchantName);
        
        let icon;
        let buttons;
        let declinedButtonLabelKey = DECLINED_BUTTON_LABEL_KEY;
        let declinedMsgClass = '';
        let messageAppendKey = '';
        let secondaryMessageAppendKey = '';
        let decisionContentClass = 'decision-content';
        const isMobileKey = '_mobile';

        if ((appStatus === APPLICATION_STATUS.CREDIT_DECLINE_HARD)) {
            if ((flow === FLOW_TYPE.TESLA)) {
                messageAppendKey = '_te';
                secondaryMessageAppendKey = messageAppendKey;
            } else if (merchantName) {
                messageAppendKey = '_merchant';
                secondaryMessageAppendKey = messageAppendKey;
            } else if (flow === FLOW_TYPE.APP_PEND) {
                messageAppendKey = '_ap';
                secondaryMessageAppendKey = messageAppendKey;
                declinedButtonLabelKey = isMobile ? `${DECLINED_BUTTON_LABEL_KEY}${isMobileKey}` : `${DECLINED_BUTTON_LABEL_KEY}${messageAppendKey}`;
            }
        } else if (appStatus === APPLICATION_STATUS.STOP_SOFT_DECLINED) {
            decisionContentClass = 'soft-decline-decision-content';
        }
        if ((appStatus === APPLICATION_STATUS.SYSTEM_ERROR) && merchantName) {
            messageAppendKey = '_merchant';
            secondaryMessageAppendKey = messageAppendKey;
        }
        if ((flow === FLOW_TYPE.TESLA)) {
            declinedButtonLabelKey = `${DECLINED_BUTTON_LABEL_KEY}_${TESLA_KEY}`;
            declinedMsgClass = 'tesla-decline-messages';
        }
        if (appStatus === APPLICATION_STATUS.LINKED_TO_DIFF_USER) {
            if (flow === FLOW_TYPE.HERMES || flow === FLOW_TYPE.PROX) {
                messageAppendKey = showPaymentSecurityMessage ? `${messageAppendKey}_paymentSecurity` : '';
                declinedButtonLabelKey = showPaymentSecurityMessage ? `${DECLINED_BUTTON_LABEL_KEY}_paymentSecurity` : DECLINED_BUTTON_LABEL_KEY;
            } else {
                messageAppendKey = showPaymentSecurityMessage ? `${messageAppendKey}_paymentSecurity_non_txn` : '_non_txn';
                declinedButtonLabelKey = showPaymentSecurityMessage ? `${DECLINED_BUTTON_LABEL_KEY}_paymentSecurity_non_txn` : DECLINED_BUTTON_LABEL_KEY;
            }
        }
        if ((appStatus === APPLICATION_STATUS.CREDIT_IN_ELIGIBLE) &&
            !(flow === FLOW_TYPE.HERMES || flow === FLOW_TYPE.PROX)) {
            messageAppendKey = '_non_txn';
            secondaryMessageAppendKey = messageAppendKey;
            declinedButtonLabelKey = `${DECLINED_BUTTON_LABEL_KEY}${messageAppendKey}`;
        }
        if (flow === FLOW_TYPE.DIRECT_APP && actor === ACTOR.MERCHANT) {
            messageAppendKey = '_daMerchant';
            secondaryMessageAppendKey = messageAppendKey;
            declinedButtonLabelKey = `${DECLINED_BUTTON_LABEL_KEY}${messageAppendKey}`;
        }

        const header = i18n(HEADER_KEY);
        const declinedButtonLabel = i18n(declinedButtonLabelKey);
        const primaryMessage = i18n(PRIMARY_MESSAGE_KEY, messageAppendKey);
        const secondaryMessage = i18n(SECONDARY_MESSAGE_KEY, secondaryMessageAppendKey);

        buttons = (
            <RedirectButton
                buttonId="declinedContinue"
                className="decisionReturnFlowAction"
                ctaLabel={declinedButtonLabel}
                actionUri={REDIRECT_SUFFIX.RETURN_REDIRECT}
            />
        );

        // For invalid email length scenarios
        if (appStatus === APPLICATION_STATUS.INVALID_EMAIL_LENGTH_DECLINED) {
            icon = (
                <span className="vx_icon vx_icon-large vx_icon-attention-large" />
            );
            decisionContentClass = 'email-length-decision-content';
            if (flow === FLOW_TYPE.HERMES || flow === FLOW_TYPE.PROX) {
                buttons = (
                    <Fragment>
                        <RedirectButton
                            buttonId="declinedContinue"
                            className="decisionReturnFlowAction"
                            ctaLabel={i18n('continueButtonLabel')}
                            actionUri={REDIRECT_SUFFIX.RETURN_REDIRECT}
                        />
                        <Button
                            data-automation-id="declinedUpdateEmail"
                            btnStyle={BUTTON_STYLE.LINK}
                            onClick={handleUpdateEmail}
                            id="declinedUpdateEmail"
                        >
                            {i18n('updateEmailButtonLabel')}
                        </Button>
                    </Fragment>
                );
            } else {
                buttons = (
                    <Button
                        data-automation-id="declinedUpdateEmail"
                        btnStyle={BUTTON_STYLE.PP_PRIMARY}
                        onClick={handleUpdateEmail}
                        id="declinedUpdateEmail"
                    >
                        {i18n('updateEmailButtonLabel')}
                    </Button>
                );
            }
        }

        const decisionDeclined = (
            <div>
                <section id="decision" className="decision-declined">
                    <Row fluid={true} className="container" id="declined">
                        <Col xs={12}>
                            <div className={decisionContentClass}>
                                {icon}
                                <h1 className="alpha" data-automation-id="decisionHeader">{header}</h1>
                                <div className={declinedMsgClass}>
                                    <p className="primary-message">{primaryMessage}</p>
                                    <p className="secondary-message">{secondaryMessage}</p>
                                </div>
                            </div>
                            <div id="DecisionDeclinedReturnFlow">
                                <Row>
                                    <Col sm={8} smOffset={2}>
                                        <div className="buttons">
                                            {buttons}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </section>
            </div>
        );

        return (<div>{decisionDeclined}</div>);
    }
}

export const mapDispatchToProps = (dispatch, ownProps) => ({
    handleUpdateEmail() {
        const { _csrf = '', flow } = ownProps;
        // fire and forget. no need to wait on response
        // as we should be redirecting immediately
        const promise = axios.request({
            method: 'post',
            url: 'clearSession',
            headers: {
                'X-CSRF-Token': _csrf
            }
        }).catch(err => {
            capeLog && capeLog(`handleUpdateEmail:clearSession:${err}`);
        });
        if (flow === FLOW_TYPE.VENICE) {
            dispatch(push(PAGE_NAME.CLOSE_PAGE));
        } else {
            setUrl(window, UPDATE_EMAIL_LINK);
        }
        return promise;
    }
});

export default connect(null, mapDispatchToProps)(injectIntl(DecisionDeclined));
